<!-- 
程式：CreateOneGroup.vue
功能：成立新的群組(view)
作者：i9400538 陳博承
完成：2021-06-03
-->
<template>
  <main class="container-fluid" :class="{'boxPadding': isBox}">
    <form class="form">
      <section class="segment" style="padding:1px 40px 10px 40px;">
        <h3>檢核結果 :</h3>
        <h4
          class="text-red"
        >可加入群組的客戶共{{addedList.length}}位 ({{unaddedList.length}}位客戶所屬群組數已超過10個，將無法加入本次所選的群組中)。</h4>
        <!--radio區塊-->
        <div class="radio radio-inline">
          <input type="radio" v-model="selectType" id="selectType1" value="1" />
          <label @click="clickLabel('1')">可加入群組的客戶({{addedList.length}})</label>
        </div>
        <div class="radio radio-inline">
          <input type="radio" v-model="selectType" id="selectType2" value="2" />
          <label @click="clickLabel('2')">已達群組上限的客戶({{ unaddedList.length }})</label>
        </div>
        <!--可加入群組的客戶-->
        <div class="row" v-show="selectType=='1'">
          <section class="w-100">
            <table
              id="added_datatable"
              class="group-table table datatable table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th width="130px">#</th>
                  <th
                    id="col_added_name"
                    :class="'sorting ' + (order_added.fieldName == 'name' ? (order_added.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('added', 'name')"
                  >姓名</th>
                  <th
                    id="col_added_id"
                    :class="'sorting ' + (order_added.fieldName == 'showid' ? (order_added.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('added', 'showid')"
                  >身分證</th>
                  <th
                    id="col_added_birthday"
                    ref="lastCol"
                    :class="'sorting ' + (order_added.fieldName == 'birthday' ? (order_added.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('added', 'birthday')"
                  >生日</th>
                </tr>
              </thead>
              <tbody
                id="added"
                @scroll="scrollmethod"
                v-if="addedList.length"
                :style="`height: ${dt_added_height}px`"
              >
                <tr v-for="(item, index) in addedList" :key="`td-added-${index}-${item.id}`">
                  <td width="130px">
                    <span class="no">{{index + 1}}</span>
                  </td>
                  <td>
                    <Tooltip
                      :position="index < 3 ? 'bottom' : 'top'"
                      :name="item.name"
                      :id="item.showid"
                      :birthday="item.birthday"
                    >
                      <a>{{item.name | getMaskName}}</a>
                    </Tooltip>
                  </td>
                  <td>{{item.showid | getMaskID}}</td>
                  <td :width="iPadWidth">
                    <div class="date">{{item.birthday | dateFormat | getMaskBirthday}}</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="empty">
                    <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                  </td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
        <!--已達群組上限的客戶-->
        <div class="row" v-show="selectType=='2'">
          <section class="w-100">
            <table
              id="unadded_datatable"
              class="group-table table datatable table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th width="130px">#</th>
                  <th
                    id="col_unadded_name"
                    :class="'sorting ' + (order_unadded.fieldName == 'name' ? (order_unadded.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('unadded', 'name')"
                  >姓名</th>
                  <th
                    id="col_sel_id"
                    :class="'sorting ' + (order_unadded.fieldName == 'showid' ? (order_unadded.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('unadded', 'showid')"
                  >身分證</th>
                  <th
                    id="col_sel_birthday"
                    :class="'sorting ' + (order_unadded.fieldName == 'birthday' ? (order_unadded.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                    @click="processCustList('unadded', 'birthday')"
                  >生日</th>
                </tr>
              </thead>
              <tbody
                id="unadded"
                @scroll="scrollmethod"
                v-if="unaddedList.length"
                :style="`height: ${dt_unadded_height}px`"
              >
                <tr v-for="(item, index) in unaddedList" :key="`td-unadded-${index}-${item.id}`">
                  <td width="130px">
                    <span class="no">{{index + 1}}</span>
                  </td>
                  <td>
                    <Tooltip
                      :position="index < 3 ? 'bottom' : 'top'"
                      :name="item.name"
                      :id="item.showid"
                      :birthday="item.birthday"
                    >
                      <a>{{item.name | getMaskName}}</a>
                    </Tooltip>
                  </td>
                  <td>{{item.showid | getMaskID}}</td>
                  <td :width="iPadWidth">
                    <div class="date">{{item.birthday | dateFormat | getMaskBirthday}}</div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="empty">
                    <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                  </td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                  <td v-show="false"></td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
      </section>
    </form>

    <!--浮動區塊 -->
    <section class="container-fluid">
      <fixed-botton v-show="!isScroll">
        <template slot="@function">
          <div>
            <button class="btn btn-default" @click="doCancel">取消</button>
            <button class="btn btn-primary mr-0" @click="doSave">儲存</button>
          </div>
        </template>
      </fixed-botton>
    </section>

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" content="資料儲存中，請稍候..."/>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
//component
import FixedBotton from "@/desktop/components/fixedBotton";
import Tooltip from "@/desktop/components/ToolTip";
import mxMask from "@/desktop/components/mxMask";
//service
import { getCustBy10Groups } from "@/service";
import { updateGroup } from "@/service";
//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: "AddToCurrentGroup",
  mixins: [commonMixin],
  components: {
    FixedBotton,
    Tooltip,
    mxMask
  },
  data() {
    return {
      grpsOfAgnt: [], //所有群組
      selectType: "1",
      selectedGroup: [], //所挑選的群組
      addedList: [], //可加入群組的客戶
      unaddedList: [], //已達群組上限的客戶
      selectedCust: [], //選取的客戶
      dt_added_height: 0, //DataTable高度(可加入群組區塊)
      dt_unadded_height: 0, //DataTable高度(已達群組上限區塊)
      order_added: {
        fieldName: "added_name",
        asc: true
      },
      order_unadded: {
        fieldName: "unadded_name",
        asc: true
      },
      mxMaskOpen: false,
      isScroll: false, //是否滾動
      scrollPostion: 25, // 顯示當前位置
      scrollPostionOffset: 10, // 1次render筆數
      isToBottom_added: false, // 是否捲動到最下面 (可加入群組的客戶)
      isToBottom_unadded: false, // 是否捲動到最下面 (已達上限的客戶)
      nowTime: 0,
      lastTime: 0,
      iPadWidth: 364
    };
  },
  watch: {
    addedList() {
      this.registerHanlink();
    },
    unaddedList() {
      this.registerHanlink();
    }
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"]),
    isBox() {
      return this.UserInfo.userType === "box";
    },
    totalCustCount() {
      return this.selectedCust.length;
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //清除搜尋框
    clearSearch() {
      this.keyword = this.currentKeyword = "";
      if (this.groupList && this.groupList.length != this.grpsOfAgnt.length) {
        this.groupList = [...this.grpsOfAgnt];
      }
    },
    //切換radio (可加入群組/已達群組上限)
    clickLabel(val) {
      if (this.selectType === val) {
        return;
      }
      this.clearSearch();
      this.selectType = val;
      this.registerHanlink();
    },
    //欄位排序
    processCustList(col, fieldName) {
      let order =
        col == "unsel"
          ? this.order
          : col == "added"
          ? this.order_added
          : this.order_unadded;
      if (order.fieldName == fieldName) {
        order.asc = !order.asc;
      } else {
        order.fieldName = fieldName;
        order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "birthday":
          setTimeout(() => {
            if (col == "added") {
              this.addedList.sort(this.dateCompareFun(sortOrder, fieldName));
            } else {
              this.unaddedList.sort(this.dateCompareFun(sortOrder, fieldName));
            }
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            if (col == "unsel") {
              this.groupList.sort(this.sortCompareFun(sortOrder, fieldName));
            } else if (col == "added") {
              this.addedList.sort(this.sortCompareFun(sortOrder, fieldName));
            } else {
              this.unaddedList.sort(this.sortCompareFun(sortOrder, fieldName));
            }
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    //初始化
    init() {
      this.mxMaskOpen = true; //開啟遮罩
      this.selectedCust = this.$route.params.selectedCust || []; //要加入到群組的客戶
      this.groupName = this.$route.params.groupName || ""; //要新增的群組名稱
      //取得已存在10個群組的客戶
      getCustBy10Groups(this.$store.state.userInfo.id).then(res => {
        this.mxMaskOpen = false; //關閉遮罩
        if (res.header && res.header.status === "200" && res.body.customers) {
          let over10groupsList = res.body.customers ? res.body.customers : [];
          if (over10groupsList && over10groupsList.length > 0) {
            if (this.selectedCust && this.selectedCust.length > 0) {
              this.selectedCust.forEach(sel => {
                let theIndex = this.checkItemIsExist(sel, over10groupsList);
                if (theIndex !== -1) {
                  this.unaddedList.push(sel); //將已超過10個群組的客戶加到unaddedList
                } else {
                  this.addedList.push(sel); //將未超過10個群組的客戶加到addedList
                }
              });
            }
          } else {
            //都沒有超過10個群組的客戶
            this.addedList = [...this.selectedCust];
          }
        } else {
          //執行出錯,顯示錯誤訊息
          this.$toast.info({ title: res.header.message });
        }
        this.resetPosition();
      });
    },
    //滾動顯示/隱藏
    handleScroll() {
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
      }, 500);
    },
    //DataTable滾動事件
    scrollmethod(e) {
      this.nowTime = +new Date();
      if (this.nowTime > this.lastTime + 150) {
        this.lastTime = this.nowTime;
        const tempPostion = e.target.scrollTop / 69 + this.scrollPostionOffset;
        this.scrollPostion = Math.max(this.scrollPostion, tempPostion);
        let type = e.target.id; //捲動的表格 added(可加入群組表格) / unadded(已達群組上限表格)
        let isBottom =
          "added" == type ? this.isToBottom_added : this.isToBottom_unadded;
        if (!isBottom) {
          if (
            e.target.scrollHeight -
              e.target.scrollTop -
              e.target.clientHeight <=
            50
          ) {
            //當滾動卷軸接近底端，縮小表格高度
            if (is_iPad) {
              if ("added" == type) {
                this.dt_added_height = $(window).height() - 380;
              } else {
                this.dt_unadded_height = $(window).height() - 380;
              }
            } else {
              if ("added" == type) {
                this.dt_added_height = $(window).height() - 450;
              } else {
                this.dt_unadded_height = $(window).height() - 450;
              }
            }
            //設定是否滾到最底端判斷
            if ("added" == type) {
              this.isToBottom_added = true;
            } else {
              this.isToBottom_unadded = true;
            }
          }
        }
      }
    },
    //畫面初始化(卷軸, 表格高度)
    resetPosition() {
      this.scrollPostion = 25;
      this.scrollPostionOffset = 10;
      this.dt_added_height = $(window).height() - 290;
      this.dt_unadded_height = $(window).height() - 290;
    },
    //儲存
    doSave() {
      if (!this.addedList || this.addedList.length == 0) {
        this.$toast.info({ title: "無可加入群組的客戶，請確認。" });
        return;
      }
      this.mxMaskOpen = true; //打開遮罩
      let addList = [];
      this.addedList.forEach(add => {
        addList.push({
          identity: add.id
        });
      });
      updateGroup(
        this.$store.state.userInfo.id,
        null,
        this.groupName,
        addList
      ).then(result => {
        this.mxMaskOpen = false; //關閉遮罩
        if (result.header.status && result.header.status == "200") {
          this.$toast.info({ title: result.header.message });
          //儲存成功後，導頁到該群組頁面
          let group = result.body || [];
          this.$router.push({
            path: `/group/1`,
            query: {
              grp_id: group.grp_id,
              grp_name: group.grp_name
            }
          });
        } else {
          //執行出錯,顯示錯誤訊息
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //取消
    doCancel() {
      this.$router.go(-1);
    },
    //欄位寬度初始化
    initColWidth() {
      if (!is_iPad) {
        this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
      } else {
        this.iPadWidth = this.$refs.lastCol.clientWidth;
      }
    },
    //檢查元素是否存在，無元素回傳-1 / 有元素回傳位置
    checkItemIsExist(item, list) {
      return list
        .map(function(e) {
          return e;
        })
        .indexOf(item.id);
    }
  },
  mounted() {
    this.initColWidth();
    window.addEventListener("scroll", this.handleScroll, true);
    this.init();
    let self = this;
    $(window).bind("orientationchange", function() {
      $(window).one("resize", function() {
        self.dt_added_height = $(window).height() - 310;
        self.dt_unadded_height = $(window).height() - 310;
        self.iPadWidth = self.$refs.lastCol.clientWidth;
        this.initColWidth();
      });
    });
  }
};
</script>

<style lang="scss" scoped>
#searchclear {
  position: absolute;
  right: 20px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}

::placeholder {
  line-height: normal;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

.body-container {
  position: fixed;
  top: 6rem;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}

.btn-custStyle {
  padding-top: 9px !important;
  width: 120px;
  height: 40px;
}
.custMain {
  padding-top: 0px !important;
  padding-bottom: 110px;
}

.group-table thead tr,
.group-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.group-table tbody {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.boxPadding {
  padding-top: 0px !important;
}
</style>